module.exports = "https://march.xiangdongcn.com:9090/xdjd/api"


//////////////////
// WEBPACK FOOTER
// ./config/server.js
// module id = dozs
// module chunks = 53